import { client } from "utils";

export const getSiteGroupsRequest = () => client.get("site-groups");
